export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 8_09.4ee2be55.jpg";